const Types = [
  { label: "全棟", value: "allHousehold", tagColor: "green" },
  { label: "戶別", value: "household", tagColor: "orange" },
  { label: "住戶", value: "user", tagColor: "geekblue" }
];

export const notificationCodeList = {
  TypesArray: Types,
  TypesMap: Types.reduce((acc, cur) => {
    return { ...acc, [cur.value]: cur };
  }, {})
};
